import { produce } from 'immer';
import { ALL_PANEL_BUTTON_PROPERTIES } from '../../panels/rightPanelButton';
import { ADD_PANEL, ADD_PANEL_UPDATE, CLEAR_PANEL_UPDATES, CLEAR_PANELS_STATE, REMOVE_PANEL, SET_ACTIVE_PANEL, SET_NUM_VISIBLE_PANEL_BUTTONS, SET_PANEL_TYPES, SET_SIDE_BETS_PANEL_STATE, TOGGLE_DEBUG_PANEL } from '../actions/panelsActions';
const initialState = {
    panels: []
};
const panelsReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_PANELS_STATE: {
                return initialState;
            }
            case SET_PANEL_TYPES: {
                draft.panels = action.payload.panelTypes.map((type) => ({ type }));
                draft.canHidePanel = action.payload.canHidePanel;
                break;
            }
            case SET_ACTIVE_PANEL: {
                const { panelType, canActionHidePanel } = action.payload;
                if (!panelType || draft.activePanelType === panelType) {
                    // Attempting to hide, and the panel itself has the ability to be hidden, but the action may not intend it to be hidden
                    // and instead may have wanted to ensure it is visible.
                    if (canActionHidePanel && draft.canHidePanel) {
                        delete draft.activePanelType;
                    }
                }
                else {
                    // make sure this panel is actually available:
                    const availablePanel = draft.panels.find((panel) => panel.type === panelType);
                    if (!availablePanel) {
                        console.error(`Tried to switch active panel to ${panelType} but it is not an available panel (${draft.panels
                            .map((panel) => panel.type)
                            .join(', ')})`);
                    }
                    else {
                        draft.activePanelType = availablePanel.type;
                        if (ALL_PANEL_BUTTON_PROPERTIES[availablePanel.type].clearUpdatesWhenActivated) {
                            delete availablePanel.numUpdates;
                        }
                    }
                }
                break;
            }
            case ADD_PANEL_UPDATE: {
                const panelState = draft.panels.find(({ type }) => type === action.payload);
                if (panelState) {
                    panelState.numUpdates = panelState.numUpdates !== undefined ? panelState.numUpdates + 1 : 1;
                }
                break;
            }
            case CLEAR_PANEL_UPDATES: {
                const panelState = draft.panels.find(({ type }) => type === action.payload);
                if (panelState) {
                    panelState.numUpdates = undefined;
                }
                break;
            }
            case ADD_PANEL: {
                const panelState = draft.panels.find((panel) => panel.type === action.payload.type);
                if (!panelState) {
                    draft.panels.push(action.payload);
                }
                break;
            }
            case REMOVE_PANEL: {
                const panelTypeToRemove = action.payload;
                draft.panels = draft.panels.filter((panel) => panel.type !== panelTypeToRemove);
                if (draft.activePanelType === panelTypeToRemove) {
                    // active panel no longer exists, default to chat
                    draft.activePanelType = 'chat';
                }
                break;
            }
            case TOGGLE_DEBUG_PANEL: {
                const numPanelsBefore = draft.panels.length;
                // remove debug panel in any case:
                draft.panels = draft.panels.filter(({ type }) => type !== 'debug');
                if (numPanelsBefore === draft.panels.length) {
                    // debug panel was not removed, so we need to toggle it on by adding it
                    draft.panels.push({ type: 'debug' });
                }
                break;
            }
            case SET_NUM_VISIBLE_PANEL_BUTTONS: {
                draft.numVisiblePanelButtons = action.payload;
                break;
            }
            case SET_SIDE_BETS_PANEL_STATE: {
                const isEnabled = action.payload;
                if (isEnabled) {
                    if (!draft.panels.some(({ type }) => type === 'sideBets')) {
                        // does not already have the side bets panel, add it (after bombs panel if possible)
                        const bombsPanelIndex = draft.panels.findIndex(({ type }) => type === 'bombs');
                        if (bombsPanelIndex !== -1) {
                            // found bombs panel
                            draft.panels.splice(bombsPanelIndex + 1, 0, { type: 'sideBets' });
                        }
                        else {
                            // add it at the end
                            draft.panels.push({ type: 'sideBets' });
                        }
                    }
                }
                else {
                    draft.panels = draft.panels.filter(({ type }) => type !== 'sideBets');
                }
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default panelsReducer;
